<template>
  <tm-translate-tooltip
    v-if="data.variant === 'translate'"
    v-bind="data"
    :anchor-element="anchorElement"
  />
  <tm-text-tooltip
    v-else
    v-bind="data"
    :anchor-element="anchorElement"
  />
</template>

<script setup lang="ts">
import type { TmTooltipDirectiveData } from '@/components/shared/tooltip/types'

import TmTextTooltip from '@/components/shared/tooltip/TmTextTooltip.vue'
import TmTranslateTooltip from '@/components/shared/tooltip/TmTranslateTooltip.vue'

defineProps<{
  data: TmTooltipDirectiveData
  anchorElement: HTMLElement
}>()
</script>
